import { render, staticRenderFns } from "./TranscodingOutputConfigEditor.vue?vue&type=template&id=c4da5370"
import script from "./TranscodingOutputConfigEditor.vue?vue&type=script&lang=js"
export * from "./TranscodingOutputConfigEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports